import debounce from 'lodash.debounce';
import { FormEventType } from '@/ui-kit/components/form/enums';
import { FormProperty } from '../enums';

const CHANGE_DEBOUNCE_TIME = 50;

const BaseForm = {
  props: {
    [FormProperty.FormGroup]: {
      type: Object,
      required: true,
    },
  },
  methods: {
    handleFormChange: debounce(
      // eslint-disable-next-line func-names
      function () { this.emitFormChange(this.formGroup.value); },
      CHANGE_DEBOUNCE_TIME,
    ),
    getIsControlCreated(controlName) {
      return !!this.getControl(controlName);
    },
    emitFormChange(value) {
      this.$emit(FormEventType.Change, value);
    },
    getControl(controlName) {
      return this.formGroup?.getControl(controlName);
    },
  },
};

export default BaseForm;
